import notifyHB from '@/config/notifyHB';
import { DocumentSigner } from '@/entities/document-signer';
import { http } from '../http';

export async function getDocumentSigners(docUlid: string) {
	try {
		const signers = await http.get<DocumentSigner[]>(
			`documents/${docUlid}/signers`,
		);
		if (signers) {
			return signers;
		} else {
			throw new TypeError('Response to GET document signers was not valid');
		}
	} catch (exception) {
		notifyHB(
			'use-case',
			'getDocumentSigners',
			`Failed to get document signers with ${exception}`,
		);
		throw exception;
	}
}
